import * as React from 'react';
import '../../style/footer.css';
import Translator from '../Translator/Translator';

class Footer extends React.Component {
  public render() {
    return (
      <div className="footer">
        <Translator path="footer.note">powered by MediConCen</Translator>
      </div>
    );
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.tsx